import httpClient from "./httpClient";
import { getPage } from "./apiClient";

export async function listarUsuariosPaginado({
  page = 0,
  size = 20,
  q = "",
  ativo,
  suppressActivityTracking = false,
} = {}) {
  return getPage(
    "/api/usuarios",
    { page, size, q: q || undefined, ativo },
    suppressActivityTracking
      ? { headers: { "X-Activity-Source": "dashboard-auto" } }
      : {}
  );
}

export async function listarTodosUsuariosAtivos({ q = "", size = 200, suppressActivityTracking = false } = {}) {
  const firstPage = await listarUsuariosPaginado({
    page: 0,
    size,
    q,
    ativo: true,
    suppressActivityTracking,
  });
  const totalPages = Number(firstPage.totalPages || 0);

  if (totalPages <= 1) {
    return firstPage.content || [];
  }

  const remainingPages = await Promise.all(
    Array.from({ length: totalPages - 1 }, (_, index) =>
      listarUsuariosPaginado({
        page: index + 1,
        size,
        q,
        ativo: true,
        suppressActivityTracking,
      })
    )
  );

  return [firstPage, ...remainingPages].flatMap((pageData) => pageData.content || []);
}

export async function listarUsuariosInativosPaginado({
  page = 0,
  size = 20,
  q = "",
} = {}) {
  return getPage("/api/usuarios/inativos", { page, size, q: q || undefined });
}

export async function criarUsuario(payload) {
  const resp = await httpClient.post("/api/usuarios", payload);
  return resp.data;
}

export async function buscarUsuario(id) {
  const resp = await httpClient.get(`/api/usuarios/${id}`);
  return resp.data;
}

export async function atualizarUsuario(id, payload) {
  const resp = await httpClient.patch(`/api/usuarios/${id}`, payload);
  return resp.data;
}

export async function atualizarMeuPerfil(payload) {
  const resp = await httpClient.put("/api/usuarios/me", payload);
  return resp.data;
}

export async function uploadMeuAvatar(file) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await httpClient.post("/api/usuarios/me/avatar", formData);
  return resp.data;
}

export async function uploadAvatarUsuario(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const resp = await httpClient.post(`/api/usuarios/${id}/avatar`, formData);
  return resp.data;
}

export async function alternarStatusUsuario(id, ativo) {
  if (ativo) {
    await httpClient.delete(`/api/usuarios/${id}`);
  } else {
    await httpClient.put(`/api/usuarios/${id}/ativar`);
  }
}

export async function resetarSenhaUsuario(id) {
  const resp = await httpClient.post(`/api/usuarios/${id}/reset-senha`);
  return resp.data;
}

export async function alterarMinhaSenha(payload) {
  const resp = await httpClient.put("/api/usuarios/me/senha", payload);
  return resp.data;
}

export async function inativarMinhaConta() {
  const resp = await httpClient.delete("/api/usuarios/me");
  return resp.data;
}

export async function listarSessoesUsuario(id) {
  const resp = await httpClient.get(`/api/usuarios/${id}/sessoes`);
  return resp.data;
}

export async function encerrarSessaoUsuario(id, sessaoId) {
  const resp = await httpClient.post(`/api/usuarios/${id}/sessoes/${sessaoId}/encerrar`);
  return resp.data;
}

export async function consultarRelatorioSessoes({
  dataInicio,
  dataFim,
  usuarioIds,
  suppressActivityTracking = false,
} = {}) {
  const resp = await httpClient.get("/api/sessoes/relatorio", {
    params: {
      dataInicio: dataInicio || undefined,
      dataFim: dataFim || undefined,
      usuarioIds: Array.isArray(usuarioIds) && usuarioIds.length ? usuarioIds : undefined,
    },
    ...(suppressActivityTracking ? { headers: { "X-Activity-Source": "dashboard-auto" } } : {}),
  });
  return resp.data;
}

export async function listarMeusDispositivosPush() {
  const resp = await httpClient.get("/api/usuarios/me/dispositivos-push");
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function desativarMeuDispositivoPush(subscriptionId) {
  const resp = await httpClient.delete(`/api/usuarios/me/dispositivos-push/${subscriptionId}`);
  return resp.data;
}

export async function listarDispositivosPushUsuario(id) {
  const resp = await httpClient.get(`/api/usuarios/${id}/dispositivos-push`);
  return Array.isArray(resp.data) ? resp.data : [];
}

export async function desativarDispositivoPushUsuario(id, subscriptionId) {
  const resp = await httpClient.delete(`/api/usuarios/${id}/dispositivos-push/${subscriptionId}`);
  return resp.data;
}
